export default __webpack_public_path__ + "static/media/laval17.75ed68e9.jpg";